"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BsHero = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const HeroWrapper = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    variant: 'hero.wrap',
    position: 'relative',
    color: 'white',
    bg: 'darkGray',
    overflow: 'hidden',
    '&.faded:after': {
        position: 'absolute',
        content: '""',
        left: 0,
        top: 0,
        background: 'linear-gradient(to bottom, rgba(0,0,0,0.5) 0%,rgba(0,0,0,0) 50%,rgba(0,0,0,0.5) 100%)',
        width: '100%',
        height: '100%',
        opacity: '.5',
    },
}));
const HeroContent = styled_components_1.default.div({
    top: 0,
    left: 0,
    position: 'absolute',
    width: '100%',
    px: 4,
    py: 5,
});
const HeroTitle = styled_components_1.default.h2((0, util_theme_sxc_1.sx2CssThemeFn)({
    textAlign: 'center',
    fontSize: [5, 6],
}));
const BsHero = props => {
    const { title, children, className, controls, faded = false } = props;
    return (react_1.default.createElement(HeroWrapper, { className: `${className || ''} ${faded ? 'faded' : ''}` },
        children,
        react_1.default.createElement(HeroContent, { className: "hero-content" },
            title && react_1.default.createElement(HeroTitle, null, title),
            controls && react_1.default.createElement(react_1.default.Fragment, null, controls))));
};
exports.BsHero = BsHero;
//# sourceMappingURL=bs-hero.js.map